document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.catalog-item').forEach((item) => {
    item.addEventListener('click', (e) => {
      document.querySelectorAll('.catalog-item.active').forEach((activeItem) => {
        activeItem.classList.remove('active');
      });
      let el = e.currentTarget;
      el.classList.toggle('active');
      setTimeout(() => {
        smoothScroll(el.querySelector('.catalog-item__sub'), 500);
      }, 100);
    });
  });

  document.querySelectorAll('.catalog-item__sub').forEach((item) => {
    item.addEventListener('click', (e) => {
      e.stopPropagation();
    });
  });

  document.querySelectorAll('.catalog-item__sub-close').forEach((item) => {
    item.addEventListener('click', (e) => {
      e.stopPropagation();
      let el = e.currentTarget.closest('.catalog-item');
      el.classList.remove('active');
    });
  });

    
  document.querySelectorAll("[data-title]").forEach((el, index) => {
    let title = el.dataset.title;
    let html = '<button class="product-info__switch ' + (index === 0 ? 'active' : '') + '">' + title + '</button>';
    let tabs = el.closest('.product-info').querySelector('.product-info__switches');
    tabs.insertAdjacentHTML('beforeend', html);
  });


  document.querySelectorAll(".product-info").forEach(block => {
    const switches = block.querySelectorAll(".product-info__switch");

    switches.forEach((el) => {
      el.addEventListener("click", (e) => {
        e.preventDefault();

        const index = [...switches].indexOf(el);

        const activeSwitch = block.querySelector('.product-info__switch.active');
        if (activeSwitch) {
          activeSwitch.classList.remove('active');
        }

        el.classList.add('active');

        const activeTab = block.querySelector('.product-info__content > .active');
        if (activeTab) {
          activeTab.classList.remove('active');
        }

        const targetTab = block.querySelector(`.product-info__content > *:nth-child(${index + 1})`);
        targetTab.classList.add('active');
      });
    });

    if (switches[0]) {
      switches[0].click()
    }
  });

  document.querySelectorAll('.product-info .button').forEach((button) => {
    button.addEventListener('click', () => {
      showModal('.modal--wholesale');
    });
  });

  document.querySelector('.modal--wholesale form').addEventListener('submit', async (e) => {
    e.preventDefault();
    const form = e.target;
    const formData = new FormData(form);
    document.querySelector('.error').style.display = 'none';
    const button = form.querySelector('button');
    button.disabled = true;
    button.classList.add('is-loading');
    try {
      const response = await fetch('https://api.logistics.hungryminds.com/email/catalog', {
        method: 'POST',
        body: formData
      });
      const json = await response.json();
      if (json.success) {
        form.reset();
        document.querySelector('.success').style.display = 'block';
        form.style.display = 'none';
      } else {
        document.querySelector('.error').style.display = 'block';
      }
    } catch {
      document.querySelector('.error').style.display = 'block';
    } finally {
      button.disabled = false;
      button.classList.remove('is-loading');
    }
  });
});